import Prism from 'prismjs';
import { useMemo } from 'react';
import type { ReactNode } from 'react';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-typescript.js';
import 'prismjs/components/prism-json.js';

import { useStyles } from '../GraderPage.style.js';

function renderToken(token: string | Prism.Token, key: number): ReactNode {
  if (typeof token === 'string') return token;
  const contents = Array.isArray(token.content)
    ? token.content
    : [token.content];
  return (
    <span key={key} className={`token-${token.type}`}>
      {contents.map(renderToken)}
    </span>
  );
}

export function HighlightedSource({
  path,
  source,
}: {
  path: string;
  source: string;
}) {
  const styles = useStyles();
  const grammar = /\.(ts|tsx)$/i.test(path)
    ? Prism.languages.typescript
    : /\.(js|jsx)$/i.test(path)
      ? Prism.languages.javascript
      : /\.json$/i.test(path)
        ? Prism.languages.json
        : undefined;
  const highlighted = useMemo(
    () => (grammar ? Prism.tokenize(source, grammar).map(renderToken) : source),
    [source, grammar],
  );

  return (
    <pre className={styles.sourceCode} aria-label={`Source file ${path}`}>
      <code>{highlighted}</code>
    </pre>
  );
}
